/** Alt text helper: inline `alt` on the image value, then Media Library `altText` on the asset (`assetAlt` in GROQ). */
export function getAlt(
  image: { alt?: string | null; assetAlt?: string | null } | null | undefined,
  fallback?: string,
): string {
  return (
    image?.alt?.trim() || image?.assetAlt?.trim() || fallback?.trim() || ""
  );
}
